import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../Utils/api";
import axios from "axios";

const initialState = {
  loading: false,
  error: null,
  leads: [],
  currentLead: null,
};

// Create Lead
export const createLead = createAsyncThunk(
  "lead/createLead",
  async (leadData, { dispatch }) => {
    const token = localStorage.getItem("auth-token");
    try {
      const response = await axios({
        method: "POST",
        url: `${baseUrl}/quote/lead`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
        data: {
          business_name: leadData.name,
          nature_of_business: leadData.nature,
          size_of_company: leadData.size,
          location_of_business: leadData.location,
          contact: leadData.contact,
          email: leadData.email,
          lead_source: leadData.source,
          product: leadData.product,
        },
      });
      dispatch(getAllLeads({ page: 1, size: 10, filters: {} }));
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);

// Get All Leads
export const getAllLeads = createAsyncThunk(
  "lead/getAllLeads",
  async ({ page = 1, size = 20, filters = {}, sortBy = 'deal_created_at', sortDirection = 'ASC' } = {}) => {
    const token = localStorage.getItem("auth-token");
    const pageQuery = page ? `&page=${page - 1}` : "";
    const sizeQuery = size ? `&size=${size}` : "";
    const sortQuery = sortBy ? `&sortBy=${sortBy}&sortDirection=${sortDirection}` : "";
    
    try {
      const response = await axios({
        method: "GET",
        url: `${baseUrl}/api/freshdesk/latest-leads?${sortQuery}${pageQuery}${sizeQuery}`,
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });
      
      // Transform the new API response structure to match the expected format in the UI
      if (response.data?.result?.content) {
        const transformedLeads = response.data.result.content.map(lead => {
          if (!lead.deal_id) return null;
          
          return {
            id: lead.deal_id,
            name: lead.deal_name,
            business_name: lead.deal_sales_account_name || lead.deal_name,
            nature_of_business: lead.deal_deal_type_name || "Health",
            size_of_company: lead.deal_sales_account_number_of_employees || "Not specified",
            location_of_business: lead.deal_sales_account_cf_location || "Not specified",
            contact: lead.deal_owner_work_number || "",
            email: lead.deal_owner_email,
            source: lead.deal_cf_channel || "Direct",
            product: lead.deal_deal_type_name || "Health",
            status: lead.deal_deal_stage_name || "Request for Quotation",
            created_at: lead.deal_created_at,
            updated_at: lead.deal_updated_at,
            owner: lead.deal_owner_name,
            deal_value: lead.deal_amount,
            currency: lead.deal_currency_name,
            client_segment: lead.deal_sales_account_cf_client_segment || "Not specified",
            deal_probability: lead.deal_probability,
            deal_age: lead.deal_age,
            last_activity: lead.deal_last_activity_at,
            expected_close_date: lead.deal_expected_close_date
          };
        }).filter(lead => lead !== null);

        return {
          result: transformedLeads,
          pagination: {
            total_count: response.data.result.property.total_elements || 0,
            page_size: response.data.result.property.page_size || size,
            current_page: response.data.result.property.page_number + 1 || page,
            total_pages: response.data.result.property.total_pages || 1
          }
        };
      }
      
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }
);

// Get Lead Summary

const leadSlice = createSlice({
  name: "lead",
  initialState,
  reducers: {
    clearLeadError: (state) => {
      state.error = null;
    },
  },
  extraReducers(builder) {
    // Create Lead
    builder.addCase(createLead.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(createLead.fulfilled, (state, action) => {
      state.loading = false;
    });
    builder.addCase(createLead.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });

    // Get All Leads
    builder.addCase(getAllLeads.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getAllLeads.fulfilled, (state, action) => {
      state.loading = false;
      state.leads = action.payload;
      console.log(action.payload);
    });
    builder.addCase(getAllLeads.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message;
    });

    // Get Lead Summary
  },
});

export const { clearLeadError } = leadSlice.actions;
export default leadSlice.reducer;
